// extracted by mini-css-extract-plugin
module.exports = {"container":"LimsStatusBar_container__1k8Yu","success":"LimsStatusBar_success__4dada","danger":"LimsStatusBar_danger__26uTJ"};